import { render, staticRenderFns } from "./ProfitAndLossIndexTable.vue?vue&type=template&id=bffde96a&scoped=true&"
import script from "./ProfitAndLossIndexTable.vue?vue&type=script&lang=js&"
export * from "./ProfitAndLossIndexTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bffde96a",
  null
  
)

export default component.exports